var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBinoculars = function SvgBinoculars(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    fill: "currentColor",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,11a7,7,0,1,0,7,7A7,7,0,0,0,7,11ZM7,23a5,5,0,1,1,5-5A5,5,0,0,1,7,23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21759,14.41766a5.17475,5.17475,0,0,1,.6507.06562A3.95537,3.95537,0,0,0,7,14a3.96031,3.96031,0,0,0-3.92828,4.71143A5.23544,5.23544,0,0,1,8.21759,14.41766Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25,11a7,7,0,1,0,7,7A7,7,0,0,0,25,11Zm0,12a5,5,0,1,1,5-5A5,5,0,0,1,25,23Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.21759,14.41766a5.17475,5.17475,0,0,1,.6507.06562A3.95537,3.95537,0,0,0,25,14a3.96031,3.96031,0,0,0-3.92828,4.71143A5.23544,5.23544,0,0,1,26.21759,14.41766Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.27216,10.19312A19.55229,19.55229,0,0,0,20.62567,9.477a5.55761,5.55761,0,0,0-9.25134,0,19.5499,19.5499,0,0,0-2.64649.71613A7.97872,7.97872,0,0,1,13.91748,22h4.165a7.97872,7.97872,0,0,1,5.18964-11.80688Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBinoculars, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/binoculars.b9f8f2b9.svg";
export { ForwardRef as ReactComponent };